
export const parseBannersFromRetailPanel = (list, isDesktop = false) => {
    return (list || []).map(({image, desktopImage, redirectionUrl, heading }) => ({
        imageUrl: isDesktop ? desktopImage : image,
        ctaLink: redirectionUrl,
        title: heading
    }));
};
